import React, { FunctionComponent } from 'react'
import { useTranslations } from '#hh/client/hooks'

export interface Error {
	type: string
	message?: string
	field?: string
	row?: number
}

export const FormErrorList: FunctionComponent<any> = ({ items, className }) => {
	const { messages } = useTranslations()
	if (!items || !items.length) {
		return null
	}

	return (
		<ul className={'form__errors'}>
			{items.map((error, index) => {
				// Try to get translation, fallback to raw message if key doesn't exist
				const message = messages[error.message] || error.message
				return <li key={index}>{message}</li>
			})}
		</ul>
	)
}
